var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "teacher_discuss_wrap" },
    [
      _c("div", { staticClass: "teacher_discuss_title" }, [
        _vm.currentRouter == "老师答疑区"
          ? _c("div", { staticClass: "teacher_discuss_tab" }, [
              _c(
                "ul",
                _vm._l(_vm.tabList, function(item, key) {
                  return _c(
                    "li",
                    {
                      key: key,
                      class: { active: _vm.listType === key },
                      on: {
                        click: function($event) {
                          return _vm.toClass(item, key)
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(item))])]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "switch_wrap" },
                [
                  _vm.region == "teacher"
                    ? _c("el-switch", {
                        attrs: {
                          "active-text":
                            _vm.userType == 2 || _vm.userType == 3
                              ? "老师已回答"
                              : "未回复",
                          "active-color": "#5397F7",
                          "inactive-color": "#E6E6E6"
                        },
                        on: { change: _vm.changeSwitch },
                        model: {
                          value: _vm.teacherAnswered,
                          callback: function($$v) {
                            _vm.teacherAnswered = $$v
                          },
                          expression: "teacherAnswered"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.currentRouter != "老师答疑区"
          ? _c("div", { staticClass: "teacher_discuss_tab" }, [
              _c("img", {
                attrs: {
                  src: require("../../../../../../../static/images/study/icon/luntan_hv.png")
                }
              }),
              _vm._v(" "),
              _c("h2", [_vm._v(_vm._s(_vm.currentRouter))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "teacher_discuss_title_right" }, [
          _vm.currentRouter == "老师答疑区"
            ? _c(
                "div",
                { staticClass: "select_wrap" },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "select_class",
                      attrs: { placeholder: "请选择班级", clearable: "" },
                      on: { change: _vm.changeClass },
                      model: {
                        value: _vm.classN,
                        callback: function($$v) {
                          _vm.classN = $$v
                        },
                        expression: "classN"
                      }
                    },
                    _vm._l(_vm.classList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentRouter == "老师答疑区"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "discuss_search" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入讨论主题、回复或评论" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.discussSearch.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.discussSearchValue,
                        callback: function($$v) {
                          _vm.discussSearchValue = $$v
                        },
                        expression: "discussSearchValue"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-button", {
                      attrs: { icon: "el-icon-search" },
                      on: { click: _vm.discussSearch }
                    })
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentRouter != "老师答疑区"
            ? _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "send_discuss",
                      on: { click: _vm.backBiscuss }
                    },
                    [_vm._v("返 回")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.currentRouter == "老师答疑区"
        ? _c("div", { staticClass: "title_msg" }, [
            _vm._v(_vm._s(_vm.introduce))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentRouter == "老师答疑区"
        ? _c("discussList", {
            attrs: {
              discussList: _vm.discussList,
              region: _vm.region,
              pageTotal: _vm.pageTotal
            },
            on: {
              jumpDetails: _vm.jumpDetails,
              currentPageFn: _vm.currentPageFn,
              searchChapter: _vm.searchChapter
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentRouter == "主题详情" && _vm.detailsId != null
        ? _c("themeDetails", {
            attrs: {
              region: _vm.detailsRegion,
              detailsId: _vm.detailsId,
              classId: _vm.classId
            },
            on: { changeRouter: _vm.changeRouter }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74359172", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74359172","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TeachClass/components/discuss/teacherDiscuss/teacherDiscuss.vue
// module id = null
// module chunks = 